import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Footer.css';

const Footer = () => {
    const { t } = useTranslation();
    const location = useLocation();

    const isSurveyPage = location.pathname.startsWith('/surveys');

    if (isSurveyPage) {
        return null;
    }

    return (
        <footer id="footer" className="site-footer text-light pt-5 pb-4">
            <div className='container mt-4'>
                <div className='row justify-content-between g-4'>
                    {/* Brand and App Downloads */}
                    <div className='col-lg-5'>
                        <div className='d-flex align-items-center mb-3'>
                            <img
                                alt="thebetteryou footer icon"
                                src="/adaptive-icon-footer.png"
                                className='img-fluid rounded-3'
                                style={{ width: "45px", marginRight: '12px' }}
                            />
                            <span className="footer-brand-title">
                                TheBetter<span className="brand-you">You</span>
                            </span>
                        </div>

                        <p className='text-secondary small mb-4 w-100 w-md-50'>
                            {/* {t('Start Your Growth Journey')} */}
                            Empowering individuals worldwide through structured psychological guidance, habit engineering, and self-discovery.
                        </p>

                        <div className="pt-2">
                            <span className="small text-uppercase tracking-wider fw-bold text-secondary d-block mb-1">Contact</span>
                            <a className="small text-decoration-none"
                                style={{ color: '#c084fc' }}
                                href="mailto:team.thebetteryou@gmail.com">
                                team.thebetteryou@gmail.com
                            </a>
                        </div>
                    </div>

                    {/* Navigation Links and Contacts */}
                    <div className='col-lg-6'>
                        <div className='row'>
                            <div className='col-6'>
                                <p className='fw-bold text-white mb-3'>{t('Quick Links')}</p>
                                <ul className="list-unstyled space-y-2">
                                    <li><Link to="/" className="footer-link">{t('Home')}</Link></li>
                                    <li><Link to="/profiles" className="footer-link">{t('Profiles')}</Link></li>
                                    <li><Link to="/about" className="footer-link">{t('About Us')}</Link></li>
                                    <li><Link to="/for-companies" className="footer-link">{t('For Companies')}</Link></li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div className='row mt-4 pt-4 border-top border-dark text-center text-secondary small'>
                    <div className='col'>
                        <p className='mb-0'>© {new Date().getFullYear()} TheBetterYou. All rights reserved.</p>
                    </div>
                    <div className='col'>
                        <p>Crafted with care for personal well-being & mindfulness. </p>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default Footer;